module.exports = __webpack_public_path__ + "img/tab-cover-zeus-club.ec792442.svg";